import COMUNI_RAW from "../data/comuni.json";

// Dataset completo dei comuni italiani (~7900) caricato localmente.
// Formato sorgente compatto: { n: nome, p: sigla provincia, c: CAP principale }.
const COMUNI = COMUNI_RAW.map((r) => ({ nome: r.n, provincia: r.p, cap: r.c }));
const CANON = new Map(COMUNI.map((c) => [c.nome.toLowerCase(), c.nome]));

// Grafia ufficiale del comune (es. "ISOLA DELLE FEMMINE" -> "Isola delle Femmine"), anche "Comune (PR)". null se non è un comune.
export function canonComune(val) {
  const s = String(val || "").replace(/\s+/g, " ").trim();
  const m = s.match(/^(.+?)\s*\(([A-Za-z]{2})\)$/);
  const name = m ? m[1] : s;
  const canon = CANON.get(name.toLowerCase());
  if (!canon) return null;
  return m ? `${canon} (${m[2].toUpperCase()})` : canon;
}

// Ricerca locale: filtra per nome che CONTIENE il testo (priorità a chi inizia con esso).
export function searchComuni(q, limit = 20) {
  const ql = (q || "").trim().toLowerCase();
  if (ql.length < 2) return [];
  const starts = [];
  const contains = [];
  for (const c of COMUNI) {
    const nl = c.nome.toLowerCase();
    if (nl.startsWith(ql)) starts.push(c);
    else if (nl.includes(ql)) contains.push(c);
    if (starts.length >= limit) break;
  }
  return [...starts, ...contains].slice(0, limit);
}

export default COMUNI;
